module.exports = __webpack_public_path__ + "u2f@2x.f319c2cfac87ba8f0e47ad4d219cd402.png";